import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getPlanzones() {
      return getState().planzones;
    },
    isPlanzonesRetrievalRequestFailure() {
      return getState().request.isFailure;
    },
    isPlanzonesRetrievalRequestPending() {
      return getState().request.isPending;
    },
    isPlanzonesRetrievalRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
